import { render, staticRenderFns } from "./ViaNajatComponent.vue?vue&type=template&id=2a156704&scoped=true&"
import script from "./ViaNajatComponent.vue?vue&type=script&lang=js&"
export * from "./ViaNajatComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a156704",
  null
  
)

export default component.exports